export function debounce3(limit, func, debounceMs = 0) {
    if (!debounceMs)
        return func;
    const recorded = [];
    let timeout = undefined;
    return function (arg1, arg2, arg3) {
        if (recorded.length >= limit)
            recorded.shift();
        recorded.push([arg1, arg2, arg3]);
        if (timeout)
            clearTimeout(timeout);
        timeout = setTimeout(() => {
            const copy = recorded.slice();
            recorded.length = 0;
            timeout = undefined;
            for (const [a1, a2, a3] of copy)
                func(a1, a2, a3);
        }, debounceMs);
    };
}
export function debounce2(limit, func, debounceMs) {
    if (!debounceMs)
        return func;
    const recorded = [];
    let timeout = undefined;
    return function (arg1, arg2) {
        if (recorded.length >= limit)
            recorded.shift();
        recorded.push([arg1, arg2]);
        if (timeout)
            clearTimeout(timeout);
        timeout = setTimeout(() => {
            const copy = recorded.slice();
            recorded.length = 0;
            timeout = undefined;
            for (const [a1, a2] of copy)
                func(a1, a2);
        }, debounceMs);
    };
}
export function debounce1(limit, func, debounceMs) {
    if (!debounceMs)
        return func;
    const recorded = [];
    let timeout = undefined;
    return function (arg1) {
        if (recorded.length >= limit)
            recorded.shift();
        recorded.push([arg1]);
        if (timeout)
            clearTimeout(timeout);
        timeout = setTimeout(() => {
            const copy = recorded.slice();
            recorded.length = 0;
            timeout = undefined;
            for (const [a1] of copy)
                func(a1);
        }, debounceMs);
    };
}
